import Api from "../../config/ApiConfig";
import * as types from "./types";

const apiUrls = {
    inboundWebhook: "api/v1/webhooks/inbound",
    outboundWebhook: "api/v1/webhooks/outbound",
    deleteWebhook:"api/v1/events"

}

export const postInboundWebhook = (payload: types.IInboundWebhookParams) =>
    Api.post(apiUrls.inboundWebhook, payload)
        .then((response) => { return response; })
        .catch((error) => { return error.response; });

export const postOutboundWebhook = (payload: types.IOutboundWebhookParams) =>
    Api.post(apiUrls.outboundWebhook, payload)
        .then((response) => { return response; })
        .catch((error) => { return error.response; });

export const getOutboundWebhookList = (params: types.IOutboundWebhookListParams) => {
    let webParams = apiUrls.outboundWebhook + "?event_id=" + params.event_id + "&type=" + params.type
    return Api.get<types.IDataOutboundWebhookList>(webParams);
}

export const putInboundTrigger = (param: string, payload: types.IPutInboundReq) =>
    Api.put(apiUrls.inboundWebhook + `/${param}`, payload)
        .then((response) => { return response })
        .catch((error) => { return error.response });

export const putOutboundTrigger = (param: string, payload: types.IPutOutboundReq) =>
    Api.put(apiUrls.outboundWebhook + `/${param}`, payload)
        .then((response) => { return response })
        .catch((error) => { return error.response });

export const deleteOutbound = (param: string) =>
    Api.delete(apiUrls.deleteWebhook + `/${param}`)
        .then((response) => { return response })
        .catch((error) => { return error.response });